<template>
    <div class="bg-surface-secondary w-100">
        <header class="bg-surface-primary border-bottom">
            <div class="container-fluid py-4">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="d-flex align-items-center gap-4">
                            <div>
                                <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                            </div>
                            <div class="vr opacity-20 my-1"></div>
                            <h1 class="h4 ls-tight">Crear nuevo paquete</h1>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="hstack gap-2 justify-content-end">
                            <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span v-else>Guardar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid vstack gap-5">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Tracking</small>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        #
                                    </span>
                                </div>
                                <input type="text" class="form-control form-control-sm" v-model="data.tracking"
                                    :class="errors.tracking ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.tracking"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Transportista</small>
                            <v-select v-model="data.carrier_id" :items="carriers" item-text="name" item-value="id"
                                hide-details no-data class="form-control form-control-sm"
                                :class="errors.carrier_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.carrier_id"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group mb-2">
                            <small class="input-title">Descripción</small>
                            <v-combobox
                                v-model="data.description"
                                chips
                                hide-details
                                multiple
                                append-icon=""
                                clearable
                                :delimiters="[',']"
                                @click:append=""
                                class="form-control form-control-sm textarea"
                                :class="errors.description ? 'is-invalid' : ''">
                                    <template v-slot:selection="{ attrs, item, select, selected }">
                                        <v-chip
                                            small
                                            v-bind="attrs"
                                            close
                                            @click:close="REMOVE(item)"
                                            :input-value="selected">
                                            <div class="nowrap">{{ item }}</div>
                                        </v-chip>
                                    </template>
                            </v-combobox>
                            <small class="invalid-feedback" v-for="(error, index) in errors.description"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Cliente</small>
                            <search-user v-model="data.user" @set_value="e => data.user_id = e" :childclass="errors.user_id ? 'is-invalid' : ''"/>
                            <small class="invalid-feedback" v-for="(error, index) in errors.user_id" :key="index">{{
                                error
                            }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Remitente (tienda)</small>
                            <search-shipper v-model="data.shipper" :childclass="errors.shipper ? 'is-invalid' : ''"/>
                            <small class="invalid-feedback" v-for="(error, index) in errors.shipper"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Largo</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE"
                                    v-model="data.lengthy" :class="errors.lengthy ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        in
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.lengthy"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Ancho</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.width"
                                    :class="errors.width ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        in
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.width"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Alto</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.tall"
                                    :class="errors.tall ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        in
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.tall"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group mb-2">
                            <small class="input-title">Peso Volumétrico</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE"
                                    v-model="data.volumetric_weight"
                                    :class="errors.volumetric_weight ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        lbs
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.volumetric_weight"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group mb-2">
                            <small class="input-title">Peso</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.weight"
                                    :class="errors.weight ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        lbs
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.weight"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Piezas</small>
                            <input type="text" class="form-control form-control-sm" @keypress="NUMBER" v-model="data.pieces"
                                :class="errors.pieces ? 'is-invalid' : ''">
                            <small class="invalid-feedback" v-for="(error, index) in errors.pieces" :key="index">{{
                                error
                            }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Embalaje</small>
                            <v-select v-model="data.packing_id" :items="packings" item-text="name" item-value="id"
                                hide-details class="form-control form-control-sm"
                                :class="errors.packing_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.packing_id"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Acción Requerida</small>
                            <v-select v-model="data.action" :items="actions" hide-details
                                class="form-control form-control-sm" :class="errors.action ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.action" :key="index">{{
                                error
                            }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
export default {
    data() {
        let random = Math.floor((Math.random() * 99999999) + 10000000)
        return {
            data: {
                packing_id: 1,
                description: [],
                carrier_id: 1,
                lengthy: 1,
                width: 1,
                tall: 1,
                volumetric_weight: 1,
                shipper: 'Amazon',
                weight: 1,
                pieces: 1,
                action: 0
            },
            errors: {},
            actions: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
            carriers: [],
            packings: [],
            loading: '',
            count: 0,
        }
    },
    created() {
        let vue = this
        vue.CARRIERS()
        vue.PACKINGS()
    },
    methods: {
        CLEAR: function(){
            let vue = this
            vue.data = {
                packing_id: 1,
                packing_id: 1,
                description: [],
                carrier_id: 1,
                lengthy: 1,
                width: 1,
                tall: 1,
                volumetric_weight: 1,
                shipper: 'Amazon',
                weight: 1,
                pieces: 1,
                action: 0,
            }
        },
        CREATE: function () {
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                let form = new FormData()
                $.each(vue.data, function(key, item) {
                    if(item != null){
                        if(key == 'description'){
                            form.append(key, JSON.stringify(item))
                        }else if(key == 'files'){
                            $.each(item, function(i, file) {
                                form.append('files[' + i + ']', file)
                            })
                        }else{
                            form.append(key, item)
                        }
                    }
                })
                axios({ url: '/packages', method: 'POST', data: form })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.CLEAR()
                        resp.data.data.isTag = true
                        vue.$store.dispatch('ADD_TAGS', resp.data.data)
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        },
        CARRIERS: function () {
            let vue = this
                axios({ url: '/all/carriers', method: 'GET' })
            .then((resp) => {
                    vue.carriers = resp.data
                })
        },
        PACKINGS: function () {
            axios({ url: '/all/packings', method: 'GET' })
                .then((resp) => {
                    this.packings = resp.data
                })
        },
        REMOVE: function(item) {
            if(this.data.description){
                this.data.description.splice(this.data.description.indexOf(item), 1)
            }
        },
    }
}
</script>